export const TABLE_COLUMNS = [
  {
    Header: 'Name',
    accessor: 'name',
    // width: 80,
  },
  {
    Header: 'Description',
    accessor: 'description',
    // width: 75,
  },
  {
    Header: 'File Name',
    accessor: 'fileName',
    // width: 80,
  },
  145,
];

export const FIELDS_MAPPING = {
  Date: 'localDate',
  'Date type': 'dateType',
  'Postal Operator': 'postalOperator',
  Carrier: 'carrier',
  Origin: 'origin',
  Dest: 'destination',
  'Mail class': 'mailClass',
  'Receptacle id': 'receptacleId',
  'Approval status': 'approvalStatus',
  Comments: 'comments',
};
